import React from "react";

export default function PageShell({ children, className = "" }) {
  return <div className={`min-w-0 space-y-6 overflow-x-hidden ${className}`}>{children}</div>;
}